import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import { Col, Form, Row } from 'react-bootstrap';

const SchoolClassOperation = ({ schoolClass, operation, onChange, onClose }) => {
    const [loading, setLoading] = useState(true);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [student, setStudent] = useState({});
    const [teacher, setTeacher] = useState({});
    const [students, setStudents] = useState([]);
    const [saving, setSaving] = useState(false);
    const [caption, setCaption] = useState("");
    const [delayFormVisible, setDelayFormVisible] = useState(false);
    const [comment, setComment] = useState("");

    useEffect(() => {
      setLoading(true);
      setTeacher(util.getCurrentUser());
      if(operation == "student_delay") setCaption("ثبت تاخیر دانش آموزان");


      var params = {login:util.getTrustedUser(), id:schoolClass.id};
      var url = config.Server+`/school/school/class/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response;
                  console.log("present absent resopnse is> ", response);
                  setStudents(response.data.students);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "comment") setComment(val);
    }

    const editDialogFooter = function(){
        return (
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                <Col style={{textAlign:"rigth"}}>
                    <Button label="انصراف" icon="pi pi-times" outlined onClick={()=>onClose()} iconPos="right" />
                </Col>
            </Row>
        )
    }
    const delayDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveDelay()}} onCancelClick={()=>{setDelayFormVisible(false)}} saving={saving} />
        )
    }
    const saveDelay = function(){
    
        setSaving(true);
        var params = {login:util.getTrustedUser(), studentId:student.id, comment:comment};
        var url = config.Server+`/school/teacher/save/student-delay`;
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
        console.log("response is>", response);
                if(response.state === "ok"){
                    
                    setSaving(false);
                    setDelayFormVisible(false);
                    setErrorMessage("با موفقيت ثبت گردید");
                    setErorVisible(true);

                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });

    }
    const showDelayForm = function (stu){
        setStudent(stu);
        if(comment == "") setComment("تاخیر در ورود به کلاس");
        setDelayFormVisible(true);
    }
    const createOperationButton1 = function (stu) {
        if(operation == "student_delay"){
            return (
            <div onClick={() => {showDelayForm(stu)}} style={{width:"32px", padding:"5px 0px 0px 0px", marginRight:"6px", border:"1px solid #b0b0b0", borderRadius:"5px", backgroundColor: "rgb(241, 200, 253)", color: "rgb(114, 47, 194)", cursor: "pointer"}}>
                <i class="bi bi-clock-history"></i>
            </div>
            );
        }
    }
    return (
        <>
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header={caption} modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{schoolClass.name}</td>
                            </tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"center", border:"1px solid #b0b0b0"}}>{teacher.Firstname + " " + teacher.Lastname}</td>
                            </tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{width:"64px", textAlign:"center", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom"}}>
                                    &nbsp;
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                students.map((row, index)=>{
                                    return(
                                    <tr>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.firstname + " " + row.lastname}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.nationalId}</td>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            {createOperationButton1(row)}
                                        </td>
                                    </tr>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>


        {
        delayFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت تاخیر ورود" modal className="p-fluid" footer={() => delayDialogFooter()} onHide={() => setDelayFormVisible(false)}>
            <table style={{marginTop:"10px", width:"100%"}}>
            <tbody>
                <tr>
                    <td style={{backgroundColor:"#F00", color:"#FF0", textAlign:"center"}}>توجه!</td>
                </tr>
                <tr>
                    <td>در صورت ثبت هیچ راهی جهت اصلاح یا حذف تاخیر وجود ندارد مگر توسط مدیر یا معاونین مدرسه</td>
                </tr>
                <tr>
                <td style={{paddingTop:"10px"}}>
                    {student.firstname + " " + student.lastname}
                </td>
                </tr>
                <tr>
                <td style={{paddingTop:"10px"}}>
                    
                </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                <td style={{padding:"1px"}}>
                    <FloatLabel>
                        <InputText value={comment} onChange={(e)=>{onInputChange(e, "comment")}}keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"right", direction:"rtl"}} />
                        <label htmlFor="username">شرح</label>
                    </FloatLabel>
                </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
            </tbody>
            </table>

        </Dialog>
        :
        <></>
        }
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
};

export default SchoolClassOperation;